mutation DeleteChatOverlay($chatId: ID!) {
  result: StreamToolsDeleteChatOverlay(chatId: $chatId) {
    id
    deleted
  }
}
